/**
 * Maps Supabase Auth errors to short, user-facing messages.
 */
export function getAuthMessage(err: unknown): string {
  const raw =
    typeof err === 'object' && err !== null && 'message' in err
      ? String((err as { message?: string }).message)
      : '';
  const code =
    typeof err === 'object' && err !== null && 'code' in err
      ? String((err as { code?: string }).code)
      : '';

  const msg = raw.toLowerCase();

  if (msg.includes('invalid login credentials') || msg.includes('invalid email or password'))
    return 'Incorrect email or password. Please try again.';
  if (msg.includes('email not confirmed'))
    return 'Please verify your email before signing in. Check your inbox.';
  if (msg.includes('user already registered') || msg.includes('already been registered'))
    return 'An account with this email already exists. Sign in or use Forgot Password.';
  if (msg.includes('password should be at least'))
    return 'Choose a stronger password (at least 6 characters).';
  if (msg.includes('rate limit') || msg.includes('too many requests') || code === 'over_request_rate_limit')
    return 'Too many attempts. Please wait a few minutes before trying again.';
  if (msg.includes('network') || msg.includes('fetch'))
    return 'Network error. Check your connection and try again.';
  if (msg.includes('email_address_invalid') || msg.includes('invalid email'))
    return 'That email address does not look valid. Please check and try again.';
  if (msg.includes('user not found'))
    return 'No account found with this email. Try signing up or check for typos.';
  if (msg.includes('weak_password'))
    return 'Choose a stronger password (at least 6 characters).';
  if (msg.includes('signup_disabled'))
    return 'Sign-up is currently disabled. Please contact support.';
  if (raw && !raw.startsWith('AuthApiError')) return raw;
  return 'Something went wrong. Please try again.';
}

/** Backward-compat alias for legacy call-sites. */
export const getFirebaseAuthMessage = getAuthMessage;
